
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"background",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff","d":"M55 5.7c-24.4 0-44.3 16.2-44.3 36.1 0 4.3.9 8.4 2.6 12.3 1.1 2.8 2.6 5.5 4.5 8 .4.5.6 1.2.4 1.9l-5.5 18c-.5 1.6 1.1 3.1 2.7 2.4l20.7-9c.4-.2.8-.2 1.3-.1 1.8.5 3.6.8 5.3 1.1 3.9.9 8 1.4 12.3 1.4 24.4 0 44.3-16.2 44.3-36.1S79.4 5.7 55 5.7z"}}),_c('path',{staticClass:"foreground",attrs:{"d":"M110.2 81.8c0-.1-.1-.2-.1-.4 3.8-4.5 6.1-10.1 6.1-16 0-15.5-15.2-28.1-34-28.1s-34 12.6-34 28.1 15.2 28.1 34 28.1c5.4 0 14.6-2.8 14.8-2.8-.2.1.6-.2.6-.2l13.8 6.3c1.6.7 3.2-.8 2.7-2.4l-3.9-12.6z"}}),_c('path',{attrs:{"fill":"#fff","d":"M112.2 98.5c-.5 0-1-.1-1.4-.3l-13.3-6.1h-.1v.1l-1.4.3c-2.9.8-9.5 2.5-13.8 2.5-19.6 0-35.5-13.3-35.5-29.6s15.9-29.6 35.5-29.6 35.5 13.3 35.5 29.6c0 5.9-2 11.5-5.9 16.4l3.8 12.2c.4 1.3 0 2.7-1 3.6-.7.6-1.5.9-2.4.9zm-14.5-9.6l14.3 6.6c.2.1.3.1.5-.1.1-.1.2-.2.1-.5l-3.9-12.6c-.1-.2-.1-.4-.1-.6l-.1-.7.4-.5c3.7-4.5 5.7-9.7 5.7-15.1 0-14.7-14.6-26.6-32.5-26.6S49.6 50.7 49.6 65.4C49.7 80.1 64.3 92 82.2 92c4 0 10.9-1.7 14.3-2.8.2-.1.4-.2.6-.2l.6-.1zm-.7 1.9l.2.6-.2-.6z"}})])
          )
        }
      }
    